export const PARTY_SCREEN_STYLE_OPTIONS = [
  { value: 'warm', label: '聚刻暖阳' },
  { value: 'classic', label: '经典紫夜' },
  { value: 'golden', label: '鎏金庆典' },
  { value: 'ocean', label: '深海蓝光' },
  { value: 'rose', label: '浪漫玫瑰' },
  { value: 'minimal', label: '简约暗黑' },
];

export const DEFAULT_PARTY_SCREEN_STYLE = 'warm';

export function normalizeScreenStyle(value) {
  const key = String(value || DEFAULT_PARTY_SCREEN_STYLE).trim().toLowerCase();
  return PARTY_SCREEN_STYLE_OPTIONS.some((o) => o.value === key) ? key : DEFAULT_PARTY_SCREEN_STYLE;
}
